import { InjectionMoldingOrderedProductChangeLog } from './injection-molding-ordered-product.model';

/** One immutable, queryable change to an order line's completed quantity. */
export interface InjectionMoldingProductionEvent {
    /** Matches the source change-log ID so backfills are idempotent. */
    id: string;
    orderedProductId: string;
    injectionMoldingOrderId: string;
    productId: string;
    /** Empty for history where the version at the time cannot be established. */
    productVersionId: string;
    type: 'increment' | 'correction';
    quantityChange: number;
    completedQuantityBefore: number;
    completedQuantityAfter: number;
    occurredOn: Date;
    createdById: string;
    /** Historic rows must not trigger future quality checks. */
    backfilled: boolean;
}

export function productionEventFromChangeLog(
    log: InjectionMoldingOrderedProductChangeLog,
    context: Pick<InjectionMoldingProductionEvent, 'orderedProductId' | 'injectionMoldingOrderId' | 'productId' | 'productVersionId' | 'backfilled'>,
): InjectionMoldingProductionEvent | null {
    if (log.type !== 'completed-quantity-added' && log.type !== 'completed-quantity-corrected') return null;
    const before = log.completedQuantityBefore;
    const after = log.completedQuantityAfter;
    const change = log.quantityChange;
    const occurredOn = new Date(log.createdOn);
    if (!log.id || !log.createdById || !Number.isSafeInteger(before) || !Number.isSafeInteger(after)
        || !Number.isSafeInteger(change) || before! < 0 || after! < 0 || after! - before! !== change
        || (log.type === 'completed-quantity-added' && change! < 1)
        || Number.isNaN(occurredOn.getTime())) return null;
    return {
        id: log.id,
        ...context,
        type: log.type === 'completed-quantity-added' ? 'increment' : 'correction',
        quantityChange: change!,
        completedQuantityBefore: before!,
        completedQuantityAfter: after!,
        occurredOn,
        createdById: log.createdById,
    };
}
